import axios from 'axios';

const apiNotification = axios.create({
  baseURL: 'https://apirastreabilidade.tutilabs.com.br/api/package/',
  headers: {
    "Accept": "application/json",
    "Accept": "multipart/form-data",
    "Content": "application/json",
    'Content': 'multipart/form-data'
  }
})

apiNotification.interceptors.request.use(
    (config)=>{

        let token = sessionStorage.getItem("token")

        if(!token){token = ""}

        config.headers.Authorization = `Bearer ${token}`

        return config
    },
    (e)=>{ return Promise.reject(e)}
)

export default apiNotification;
